// @flow
import {Switch} from '@homeaway/react-form-components';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Experiment from '../Experiment/Experiment';
// //
// Begin: SERP dependencies
import {
    trigger as triggerEdapEvent,
    GENERIC_EVENT
} from '../../../utils/edapWrapper';
import type {State as ReduxState} from '../../../reducers/index';
import {HA_TRAVSEG_SERP_FILTER} from '../../../abacus/experiments';
// //
// End: SERP dependencies

import {FAMILY_FRIENDLY_FILTER_NAME} from '../../constants';
import isFamilyFriendlySelected from '../../utils/isFamilyFriendlySelected';

import './ForFamiliesFilter.less';

type Props = {
    onSwitchChange: (SyntheticEvent<HTMLInputElement>) => void,
    checked: boolean,
    className?: string
};

export class ForFamiliesFilter extends PureComponent<Props> {
    handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
        this.props.onSwitchChange(event);
        if (event && event.currentTarget) {
            triggerEdapEvent(GENERIC_EVENT, {
                eventaction: `filters ${
                    event.currentTarget.checked ? 'applied' : 'removed'
                }`,
                eventlabel: 'family friendly'
            });
        }
    };

    render() {
        const {
            handleChange,
            props: {checked, className}
        } = this;

        return (
            <div
                className={`ForFamiliesFilter ${className || ''}`}
                data-wdio={'ForFamiliesFilter'}
            >
                <div className={'ForFamiliesFilter__labels'}>
                    <div className={'ForFamiliesFilter__primaryLabel'}>
                        {'For families'}
                    </div>
                    {'Browse properties that are good for families with kids'}
                </div>
                <Switch
                    id={'ForFamilies__switch'}
                    name={FAMILY_FRIENDLY_FILTER_NAME}
                    checked={checked}
                    onChange={handleChange}
                />
            </div>
        );
    }
}

type ContainerProps = Props & {isVisible: boolean};

function ForFamiliesFilterContainer({isVisible, ...rest}: ContainerProps) {
    return isVisible ? (
        <Experiment experimentName={HA_TRAVSEG_SERP_FILTER}>
            {({evaluationData: {value}}) =>
                value ? <ForFamiliesFilter {...rest} /> : null
            }
        </Experiment>
    ) : null;
}

const mapStateToProps = ({
    searchParams,
    segmentation: {hasEnoughSpaceInFilterBar}
}: ReduxState) => ({
    checked: isFamilyFriendlySelected(searchParams),
    isVisible: !hasEnoughSpaceInFilterBar
});

export default connect(mapStateToProps)(ForFamiliesFilterContainer);
